/** Frozen source of the standalone Young V2 contract bundle. No application dependencies. */
export type ResourceConfig = Record<string, number | boolean>;
export type Parameter = {type: "number" | "boolean"; label: string; unit?: string; minimum?: number; maximum?: number; step?: number; default: number | boolean};
export const parameterSchema: Record<string, Parameter> = {
  lambdaNm: {type:"number", label:"λ initiale",unit:"nm",minimum:400,maximum:700,step:5,default:650},
  distanceM: {type:"number",label:"D initiale",unit:"m",minimum:0.5,maximum:3,step:0.05,default:1.5},
  slitSpacingMm: {type:"number",label:"a initial",unit:"mm",minimum:0.2,maximum:0.5,step:0.01,default:0.3},
  showInterfringe: {type:"boolean",label:"Afficher l’interfrange",default:false},
  studentCanChangeLambda: {type:"boolean",label:"Élève peut modifier λ",default:true},
  studentCanChangeDistance: {type:"boolean",label:"Élève peut modifier D",default:true},
  studentCanChangeSlitSpacing: {type:"boolean",label:"Élève peut modifier a",default:true},
};
export const defaultConfig: ResourceConfig = Object.fromEntries(Object.entries(parameterSchema).map(([key,p])=>[key,p.default]));
export function validateConfig(input: unknown, fromUrl=false) {
  const config={...defaultConfig}; const errors:string[]=[];
  if (!input || typeof input!=="object" || Array.isArray(input)) return {config,errors:["Configuration invalide."]};
  for(const [key,raw] of Object.entries(input)) {
    const p=Object.hasOwn(parameterSchema,key)?parameterSchema[key]:undefined;
    if(!p){errors.push(`Paramètre inconnu : ${key}`);continue;}
    const value=fromUrl && typeof raw==="string" ? p.type==="number" ? (raw.trim()?Number(raw):NaN) : raw==="true"?true:raw==="false"?false:raw : raw;
    if(typeof value!==p.type || (typeof value==="number" && (!Number.isFinite(value)||value<p.minimum!||value>p.maximum!|| (p.step!==undefined && Math.abs((value-p.minimum!)/p.step-Math.round((value-p.minimum!)/p.step))>1e-7)))) {errors.push(`Valeur invalide : ${p.label}`);continue;}
    config[key]=value as number|boolean;
  }
  return {config,errors};
}
export function configFromSearch(search:string) {
  const params=new URLSearchParams(search); const errors:string[]=[];
  if(params.getAll("v").length>1)errors.push("Version répétée.");
  const version=params.get("v")??"2";
  params.delete("v");
  for(const key of new Set(params.keys()))if(params.getAll(key).length>1)errors.push(`Paramètre répété : ${key}`);
  const result=validateConfig(Object.fromEntries(params),true);
  return {...result,version,errors:[...errors,...result.errors]};
}
export function publicResourceUrl(origin:string,config:ResourceConfig) {
  const result=validateConfig(config);
  if(result.errors.length)throw new Error(result.errors.join(" · "));
  const url=new URL("/animations/young-double-slit",origin);url.searchParams.set("v","2");
  for(const [key,value] of Object.entries(result.config))url.searchParams.set(key,String(value));
  return url.href;
}
export const protocolVersion=1;
export const resourceId="young-double-slit";
export const resourceVersion=2;
export type MessageType="ready"|"configure"|"parameter_changed"|"measurement_taken"|"error";
export function envelope(type:MessageType,instanceId:string,payload:unknown={}) {return {type,protocolVersion,resourceId,resourceVersion,instanceId,payload};}
export function isMessage(data:unknown,instanceId?:string):data is ReturnType<typeof envelope> {
  if(!data||typeof data!=="object")return false;
  const d=data as ReturnType<typeof envelope>;
  return d.protocolVersion===1&&d.resourceId===resourceId&&d.resourceVersion===2&&typeof d.instanceId==="string"&&d.instanceId.length>0&&d.instanceId.length<=128&&(!instanceId||instanceId===d.instanceId)&&["ready","configure","parameter_changed","measurement_taken","error"].includes(d.type);
}
export function interfringeMm(config:ResourceConfig) {return Number(config.lambdaNm)*1e-9*Number(config.distanceM)/(Number(config.slitSpacingMm)*1e-3)*1000;}
